export const getFleetFormValues = (values) => {
  return {
    name: values.name,
    organisationId: values.orgIds,
    imeis: values.vehicleImei,
    status: values.status,
    description: values.description,
  };
};
